<template>
  <div class="login">
    <div class="horizontal-layout horizontal-menu 1-column menu-expanded blank-page blank-page pace-done">
      <div class="app-content content" id="app">
        <div class="content-wrapper">
          <div class="content-body">
            <section class="flexbox-container">
              <div class="col-12 d-flex align-items-center justify-content-center">
                <div class="col-md-4 col-10 box-shadow-2 p-0">
                  <div class="card border-grey border-lighten-3 m-0 p-3">
                    <div class="card-header border-0 pb-0">
                      <div class="card-title text-center">
                        <div class="p-1">
                          <h1>
                          <strong>{{$t('password_recovery_title')}}</strong>
                          </h1>
                        </div>
                      </div>
                    </div>
                    <div class="card-content">
                      <div class="card-body" v-if="displayForm === true">
                        <div class="mb-2" v-if="errors.first('email')">
                          <small class="text-danger d-block">{{ errors.first('email') }}</small>
                        </div>
                        <form class="form-horizontal form-simple" @submit.prevent="doRecovery">
                          <fieldset class="form-group position-relative has-icon-left">
                            <input name="email" v-validate="'required|email'" @input="updateUser" class="form-control form-control-lg input-lg" id="user-name" v-bind:placeholder="$t('email')" required="" aria-invalid="false">
                            <div class="form-control-position">
                              <i class="ft-mail"></i>
                            </div>
                          </fieldset>
                          <button class="btn btn-info round btn-lg btn-block">
                            <i class="ft-unlock"></i> {{$t('password_recovery_btn')}}
                          </button>
                        </form>
                      </div>
                      <div class="card-body" v-if="displayForm === false">
                        <p v-html="$t('noted')"></p>
                        <p>{{ $t('you_will_received_email_with_link')}}</p>
                      </div>
                    </div>
                    <div class="card-footer border-0">
                      <p class="float-sm-left text-center m-0"
                         v-if="displayForm === true">
                        <router-link to="/login" class="card-link">{{$t('password_recovery_login')}}</router-link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      displayForm: true
    }
  },
  computed: {
    resetPasswordErrors () {
      return this.$store.state.resetPassword.errors
    }
  },
  methods: {
    updateUser (e) {
      this.$store.state.userName = e.target.value
    },
    doRecovery () {
      const data = {
        cmd: 'reset_password',
        email: this.$store.state.userName,
        language: navigator.language,
        url: `${window.location.protocol}//${window.location.host}/change-password`
      }
      this.$socket.send(data)
    }
  },
  watch: {
    'resetPasswordErrors' (oldValue, newValue) {
      if (newValue.length > 0) {
        this.displayForm = true
        const field = this.$validator.fields.find({ name: 'email' })

        this.$validator.errors.add({
          'id': field.id,
          'field': field.name,
          'scope': field.scope,
          'msg': this.$t(newValue[0]),
          'rule': 'required'
        })
      } else {
        this.displayForm = false
      }
    }
  }
}

</script>
<style lang="scss">
    @import '../app-assets/css/pages/login-register.css';
</style>
